import Grid from '@mui/material/Grid';
import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete.tsx';
import { LANGUAGE_LOCAL_STORAGE_KEY } from '@openx/utils/i18n/constants.ts';
import { getCurrentLocale, getLocales } from '@openx/utils/i18n/locale.ts';
import { type JSX, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const DEFAULT_AUTOCOMPLETE_WIDTH = '128px';

export const LanguagePicker = (): JSX.Element => {
  const [langSymbol, setLangSymbol] = useState<string>(getCurrentLocale());

  const { i18n, t } = useTranslation();

  const opts = useMemo(() => getLocales(t), [t]);

  return (
    <Grid data-test="choose-language" sx={{ width: 128 }}>
      <AutoComplete
        slotProps={{ popper: { style: { minWidth: DEFAULT_AUTOCOMPLETE_WIDTH, width: 'fit-content' } } }}
        textFieldProps={{
          margin: 'dense',
        }}
        options={opts}
        disableClearable
        value={opts.find(lang => lang.id === langSymbol) || opts[0]}
        getOptionDisabled={option => langSymbol === option.id}
        getOptionLabel={option => option.name}
        onChange={(_, option) => {
          setLangSymbol(option.id);
          i18n.changeLanguage(option.id);
          window.localStorage.setItem(LANGUAGE_LOCAL_STORAGE_KEY, option.id);
        }}
      />
    </Grid>
  );
};
